import { App } from "vue";
import {IconMap} from "@/components/Icons/config/iconMap";

export function registerIconsGlobally(app: App<Element>, iconMap: IconMap) {
    for (const [key, value] of Object.entries(iconMap)) {
        app.component(key, value);
    }
}
